import React from "react";
import { LucideIcon } from "lucide-react";
import { formatPrice } from "../../utils/utility";

interface StatsCardProps {
  title: string;
  value: string | number;
  trend: number;
  icon: LucideIcon;
  color: string;
  isCurrency?: boolean;
}

export function StatsCard({
  title,
  value,
  trend,
  icon: Icon,
  color,
  isCurrency = false,
}: StatsCardProps) {
  const displayValue = isCurrency ? formatPrice(Number(value)) : value;

  return (
    <div className="bg-white rounded-lg p-3 md:p-4 shadow-sm flex flex-col justify-between max-w-full">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm md:text-sm text-gray-600">{title}</p>
          <h3 className="text-lg md:text-xl font-bold mt-1">{displayValue}</h3>
        </div>
        <div className={`p-2 md:p-2 rounded-lg ${color}`}>
          <Icon className="w-3 h-3 md:w-5 md:h-5" />
        </div>
      </div>
      <div className="mt-2 md:mt-2 flex items-center">
        <span
          className={`text-sm md:text-sm ${
            trend >= 0 ? "text-green-600" : "text-red-600"
          }`}
        >
          {trend >= 0 ? "+" : ""}
          {trend}%
        </span>
        <span className="text-sm md:text-sm text-gray-500 ml-2">vs last month</span>
      </div>
    </div>
  );
}
